import {format} from "date-fns";

const masksInEn = {
	"dd/MM/yyyy":"MM/dd/yyyy",
	"dd/MM/":"MM/dd"
};

const formatDate = (date: Date, currentLanguage: string = "pt", time: boolean = false, removeFromDate?: "dd/" | "MM/" | "/yyyy" | "dd/MM/"|"dd/MM/yyyy" ):string => {
	if(!date)
		return "";

	let mask = "dd/MM/yyyy";

	if(currentLanguage === "en")
		mask = "MM/dd/yyyy";

	if(removeFromDate)
		if(currentLanguage === "en" && (removeFromDate==="dd/MM/" || removeFromDate === "dd/MM/yyyy")){
			mask = mask.replace(`${masksInEn[removeFromDate]}`, "");
		}else{
			mask = mask.replace(`${removeFromDate}`, "");
		}

	if(time)
		mask += " HH:mm";

	return format(new Date(date), mask);
};

export const formatDateWithoutHours = (date: Date): Date | null => {
	if(date === null){
		return date;
	}

	return new Date(date.setHours(0,0,0,0));
};

export default formatDate;
